import Vue from "vue";
import { scrollBoard } from "@jiaminghi/data-view";

Vue.use(scrollBoard);
